/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 17:44:46
 * @LastEditTime: 2022-01-23 12:48:43
 * @LastEditors: wangshengqiang
 * @Description: 理赔流程模块中使用子组件
 */
import React from 'react';
import { Badge } from 'zarm';
import './index.less';

const ClaimSteps = props => {
  const {
    attrs,
    label
  } = props;
  const {
    dataSource = []
  } = attrs;

  if (dataSource.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "c-StepsComponent"
  }, dataSource.map((item, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "title"
    }, /*#__PURE__*/React.createElement("div", {
      className: "left"
    }, /*#__PURE__*/React.createElement(Badge, {
      theme: "primary"
    })), /*#__PURE__*/React.createElement("div", {
      className: "right"
    }, "\u7B2C", index + 1, "\u6B65\uFF1A", item.title)), /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, item.content));
  }));
};

export default ClaimSteps;